import clsx from "clsx";
import PropTypes from "prop-types";
import { forwardRef } from "react";

import { JobOutlook } from "@features/career-details/components";
import { InterestTags, SalaryRate } from "@features/career-matches/components";
import { ListItem } from "@features/ui";
import { isNullish } from "@lib/app.helpers";

import { WORK_HOURS_PER_YEAR } from "src/constants";

import "./base-career.list-item.scss";

export const BaseCareerListItem = forwardRef(
  ({ career, className, index, tags, onClick, icon }, ref) => {
    const {
      title,
      shortDescription,
      tags: interestTags,
      annualEarningsMedian,
      outlook,
    } = career ?? {};

    const listItem = (
      <ListItem
        ref={ref}
        index={index}
        className={clsx("base-career-list-item", className)}
        onClick={() => onClick?.(career, index)}
        icon={icon}
      >
        <div className="header">
          <span>
            {title}
            {/* Empty div to provide gap after title */}
            <div />
            {!isNullish(annualEarningsMedian) && (
              <SalaryRate value={annualEarningsMedian / WORK_HOURS_PER_YEAR} />
            )}
            {!isNullish(outlook) && <JobOutlook value={outlook} compact />}
          </span>
        </div>
        <div className="description">{shortDescription}</div>
        {interestTags && <InterestTags tags={interestTags} />}
      </ListItem>
    );

    return tags ? (
      <div className="base-career-list-item-tagged">
        {listItem}
        <div className="tags-container">{tags}</div>
      </div>
    ) : (
      listItem
    );
  },
);

BaseCareerListItem.displayName = "Base Career List Item";

BaseCareerListItem.propTypes = {
  career: PropTypes.object,
  className: PropTypes.string,
  index: PropTypes.number,
  onClick: PropTypes.func,
  tags: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  icon: PropTypes.node,
};
